const B2C = 'b2c',
    COMMUNICATION_BRIDGE = 'communicationBrige',
    MARKETING_FLOWS = {
        REGISTER: 'register',
        REGISTER_IN_LOGIN: 'register_in_login',
    };


export {B2C, COMMUNICATION_BRIDGE, MARKETING_FLOWS};